import { Button } from "antd";
import { useState } from "react";
import ModalWithForm, { FieldProps } from "src/components/ModalWithForm";
import { Tag } from "src/models/TagModel";
import { useUpdateTagMutation } from "src/store/apis/Tags";

interface Props {
  record: Tag | null;
}

export default function EditModal({ record }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);

  const [updateTag, { isLoading: isLoadingTags }] = useUpdateTagMutation();

  const fields: FieldProps<Tag>[] = [
    {
      label: "English Name",
      name: "name",
      type: "text",
      inputProps: {
        name: "name",
        disabled: isFormDisabled,
        value: record?.name,
      },
    },
    {
      label: "Arabic Name",
      name: "nameAr",
      type: "text",
      inputProps: {
        name: "nameAr",
        disabled: isFormDisabled,
        value: record?.nameAr,
      },
    },
  ];

  async function handleConfirm(
    /*Necessary because offer tags typing is inconsistent*/
    formData: Tag,
  ) {
    if (!record) return;

    try {
      await updateTag({
        data: {
          id: record.id,
          name: formData.name,
          nameAr: formData.nameAr,
        },
      }).then(() => {
        setIsModalOpen(false);
        setIsFormDisabled(true);
      });
    } catch (error) {
      // TODO: implement toaster
      console.error(error);
    }
  }

  return (
    <>
      <div className="flex justify-between gap-4">
        <Button
          className={
            "text-12 border-0 font-bold uppercase bg-primary text-white disabled:bg-gray-500"
          }
          onClick={() => setIsModalOpen(true)}
          disabled={!record}
        >
          Edit
        </Button>
      </div>
      <ModalWithForm
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        afterClose={() => {
          setIsFormDisabled(true);
        }}
        onConfirm={handleConfirm}
        isLoading={isLoadingTags}
        mode="edit"
        isEditing={!isFormDisabled}
        onEdit={() => setIsFormDisabled((prev) => !prev)}
        title={<h3>Edit Tag: {record?.id}</h3>}
        initialValues={{
          name: record?.name,
          nameAr: record?.nameAr,
        }}
        fields={fields}
      />
    </>
  );
}
